<template>
  <div class="input_group">
    <label>{{ label }} <span v-if="required">*</span></label>
    <div class="password_input">
      <input
        :type="showPassword? 'text': 'password'"
        v-bind="$attrs"
        @input="$emit('update:modelValue', $event.target.value)"
        :value="modelValue"
        :placeholder="Placeholder"
        :required="required"
        :class="inputClass"
      />
      <span @click="togglePassword"><i :class="showPassword?'ri-eye-line' : 'ri-eye-off-line'"></i></span>
    </div>
  </div>
</template>
  
  <script>
export default {
  name: "f-password",
  props: {
    modelValue: [String, Number],
    Placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    inputClass: {
      type: String,
      default: "",
    },
    required:{
      type:Boolean,
      default:false
    },
  },
  data(){
    return{
        showPassword:false,
    }
  },
  methods:{
    togglePassword(){
        this.showPassword = !this.showPassword
    }
  }
};
</script>
  
  <style scoped>
.input_group {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  text-align: start;
  gap: 7px;
  width: 100%;
}

.input_group h2 {
  font-weight: 500;
  font-size: 24px;
  line-height: 40px;
}

.input_group label {
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  text-align: start;
}

.input_group label span {
  color: red;
}

.input_group .password_input{
    width: 100%;
    position: relative;
}

.input_group .password_input input {
  width: 100%;
  text-indent: 10px;
  border-radius: 8px;
  border: 1px solid #ecebf2;
  padding: 11px 0;
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  box-shadow: 0 2px 4px 0 #0000000a;
  color: black;
  outline: none;
}

.input_group .password_input input:focus {
  border: 2px solid #0d3182;
}

.password_input span{
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
}

.password_input span i{
    font-size: 20px;
}

.wrong {
  border: 1px solid red !important;
}
</style>